const BRL_TOKENS = ["BRL", "R$"];

export function isBRLCurrency(currency) {
    const raw = String(currency == null ? "" : currency).toUpperCase();

    return BRL_TOKENS.some(token => raw.includes(token));
}

export function currencySymbol(currency) {
    return isBRLCurrency(currency) ? "R$" : "US$";
}

export function formatMoney(value, currency) {
    if (value == null || value === "") {
        return null;
    }

    const isBRL = isBRLCurrency(currency);
    const amount = Number(value);

    if (!Number.isFinite(amount)) {
        return null;
    }

    const rounded = Math.round(amount * 100) / 100;

    const formatted = rounded.toLocaleString(isBRL ? "pt-BR" : "en-US", {
        minimumFractionDigits: Number.isInteger(rounded) ? 0 : 2,
        maximumFractionDigits: 2
    });

    return `${currencySymbol(currency)} ${formatted}`;
}
